import { Component } from '@angular/core';
import { Message } from 'primeng/api';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { DadosProfissoesFormComponent } from '../dados-profissoes-form/dados-profissoes-form.component';
import {
  editProfession,
  loadProfession,
} from 'src/app/store/profession/profession.actions';
import { IProfession } from 'src/app/shared/interfaces/profession/iprofession';
import { Store } from '@ngrx/store';
import { selectProfessionLista, selectProfessionLoading } from 'src/app/store/profession/profession.selectors';
import { DisableAlertComponent } from 'src/app/shared/components/disable-alert/disable-alert.component';

@Component({
  selector: 'app-dados-profissoes',
  templateUrl: './dados-profissoes.component.html',
  styleUrls: ['./dados-profissoes.component.scss'],
})
export class DadosProfissoesComponent {
  messages: Message[] = [
    {
      severity: 'warn',
      summary: '',
      detail:
        'Preencha essas informações pela primeira vez e salve as suas preferências. ',
    },
  ];

  guardarDado!: any;
  isLoading$ = this.store.select(selectProfessionLoading)
  constructor(
    public dialogService: DialogService,
    private store: Store<IProfession>
  ) {}
  ref: DynamicDialogRef | undefined;

  ngOnInit(): void {
    this.store.dispatch(loadProfession());
  }
  lista$ = this.store.select(selectProfessionLista);

  mostrarModalInativar: boolean = false;
  mostrarModalAtivar: boolean = false;

  //fucntions

  edit(item: IProfession) {
    this.ref = this.dialogService.open(DadosProfissoesFormComponent, {
      header: 'Especialidades:',
      dismissableMask: true,
      width: '45%',
      contentStyle: { overflow: 'auto' },
      baseZIndex: 10000,
      data: {
        item: item,
      },
    });
  }

  public fecharDialog() {
    this.ref?.destroy();

    this.mostrarModalInativar = false;
    this.mostrarModalAtivar = false;
  }

  mudarStatusProfissao(item: IProfession) {
    
    this.guardarDado = item;
    if(item.enable){
      this.mostrarModalInativar = true;
    } else {
      this.mostrarModalAtivar = true;
    }
    // this.ref = this.dialogService.open(DisableAlertComponent, {
    //   header: 'Adicionar profissão:',
    //   dismissableMask: true,
    //   width: '45%',
    //   contentStyle: { overflow: 'auto' },
    //   baseZIndex: 10000,
    //   data: {
    //     item: item,
    //   },
    // });
  }

  changeStatusCard(dado?: any) {
    //console.log(dado);
    let item = { ...this.guardarDado };
    item.enable = !item.enable;

    this.store.dispatch(
      editProfession({
        profession: item as IProfession,
        id: (item as IProfession).id as number,
      })
    );
    this.fecharDialog();
  }

  modalDisable() {
    console.log(this.guardarDado);
    let item = { ...this.guardarDado };
    item.enable = !item.enable;

    this.store.dispatch(
      editProfession({
        profession: item as IProfession,
        id: (item as IProfession).id as number,
      })
    );
    this.fecharDialog();
  }
}
